import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.company.XeroDemoOrganisationPopup.ChoicePopup', {
    title: 'Prepopulating a demo organisation with sample data',
    description:
        'We noticed that you have connected to a demo company in Xero. Would you like to prepopulate the demo company with sample data?',
    prepopulateData: 'Yes, prepopulate with sample data',
    notPrepopuluteData: 'No, I will set up everything myself',
});
